var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-account-choice",class:( _obj = {}, _obj['variant-'+_vm.variant] = _vm.variant, _obj )},[_c('div',{staticClass:"flex-content"},[_c('div',{staticClass:"width-100 relative text-center"},[_c('svgicon',{attrs:{"name":_vm.variant}})],1)]),_c('div',{staticClass:"checkbox-wrap"},[_c('Input',{attrs:{"type":"checkbox","width":"inline"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }